'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');

const userAgentFromServerContext = react.createContext("");
const useUserAgentFromServer = () => {
  return window !== void 0 ? window.navigator?.userAgent : "";
};
function UserAgentFromServerContextProvider({
  userAgent,
  children
}) {
  return /* @__PURE__ */ jsxRuntime.jsx(userAgentFromServerContext.Provider, { value: userAgent, children });
}

exports.UserAgentFromServerContextProvider = UserAgentFromServerContextProvider;
exports.useUserAgentFromServer = useUserAgentFromServer;
exports.userAgentFromServerContext = userAgentFromServerContext;
//# sourceMappingURL=userAgentFromServer.cjs.map
